import React from 'react';

import { DateTime } from 'luxon';
import { useModal } from 'src/shared/hooks/use-modal';
import { Button, Modal, Table } from 'src/shared/ui/elements';
import { currency } from 'src/shared/utils/currency';
import { classStatusEnum } from 'src/event/service/event.service';
import { useTokenContext } from 'src/account/shared/service/token.context';
const ScheduleTableRow = ({ $item: schedule }) => (
  <tr>
    <td>
      {schedule?.isDueToday
        ? 'Due Today'
        : DateTime.cast(schedule.date)?.toFormat('MM/dd/yyyy')}
    </td>
    <td>{currency(schedule.fee)}</td>
  </tr>
);

const ScheduleTableMobile = ({ $item: schedule }) => (
  <li className="pa-16 shadow-2">
    <div className="mt-8">
      <p>
        Date: {DateTime.cast(schedule.date)?.toFormat('MM/dd/yyyy')}
        {schedule?.isDueToday ? ' (Due Today)' : null}
      </p>
      <p>Price: {currency(schedule.fee)}</p>
    </div>
  </li>
);
export const EventPaymentSchedule = ({
  schedule,
  event,
  isPrimary = false,
}) => {
  const { decoded } = useTokenContext();
  const impersonating = Boolean(decoded?.adminId);
  const { isOpen, actions } = useModal();

  const unAvailableEvent =
    event?.registrationStatus === classStatusEnum.SoldOut ||
    event?.registrationStatus === classStatusEnum.JoinWaitlist ||
    event?.registrationStatus === classStatusEnum.Complete;
  if (!schedule?.length || (unAvailableEvent && !impersonating)) {
    return null;
  }
  return (
    <div>
      <Button
        className={`text ${!isPrimary ? '!tw-text-[#29303d]' : ''}`}
        onClick={actions.open}
      >
        View Payment Schedule
      </Button>
      {isOpen && (
        <Modal $actions={actions} $title="Payment Schedule">
          <Modal.Content>
            <div className="tw-max-h-[60vh] tw-overflow-auto">
              <p className="tw-font-semibold tw-mb-2">{event.effectiveName}</p>
              <Table
                $headers={['Date', 'Price']}
                $items={schedule}
                $desktopItem={ScheduleTableRow}
                $mobileItem={ScheduleTableMobile}
                $isHeaderSelectable={false}
                $isSelectionHeaderSelected={false}
                $maxItems={5}
                $selectionHeaderName={`event-payment-schedule-${event.id}`}
              />
            </div>
          </Modal.Content>
        </Modal>
      )}
    </div>
  );
};
